/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_CenterInputs */

const en_help_center = /** @type {(inputs: Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const nl_help_center = /** @type {(inputs: Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hulp`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Help_CenterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const help_center = /** @type {((inputs?: Help_CenterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_CenterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_help_center(inputs)
	return en_help_center(inputs)
});